module.exports = __webpack_public_path__ + "static/media/A3.6df39c1c.mp3";